import { TextBannerBlock as TextBannerBlockType } from "../../types";
import MarkdownText from "../helper/MarkdownText";

import styles from "../../styles/TextBannerBlock.module.less";

type TextBannerBlockProps = {
  className: string;
  block: TextBannerBlockType;
};

const TextBannerBlock = ({ block, className }: TextBannerBlockProps) => {
  return (
    <div className={className}>
      <h3 className={styles.title}>
        <MarkdownText value={block.text} />
      </h3>
    </div>
  );
};

export default TextBannerBlock;
